import '@babel/polyfill';
import React, {Fragment, Suspense, lazy} from 'react'
import Router from 'next/router';
import Block from '../adapters/helpers/Block';
import { campaignOverlayStatus } from '../adapters/helpers/Utils';
import PropTypes from 'prop-types'
import {asyncForEach} from '../adapters/helpers/Utils';
import contentfulClient from '../adapters/model/ContentfulClient';
import dynamic from 'next/dynamic';
const GTMScriptFunction = lazy(() => import('../components/GTMScriptFunction'));
const Meta = lazy(() => import('../components/Meta/Meta'));
const Loader = lazy(() => import('../adapters/helpers/Loader'));

class Page extends React.Component {

  componentDidMount() {
    Router.beforePopState(({as}) => {
      location.href = as;
    });
  }

  static async getInitialProps({ asPath, query }) {
    const slug = query?.slug || asPath;
    const siteLocale = process.env.SITE_LOCALE;
    let languageCode, countryCode;
    if (siteLocale) {
      languageCode = siteLocale.substring(0, 2);
      countryCode = siteLocale.slice(-2);
    } else {
      const client = await contentfulClient.getClient();
      const locales = await client.getLocales();
      const defaultLocale = locales.items.find(locale => locale.default);
      countryCode = defaultLocale.code.slice(-2);
      languageCode = defaultLocale.code.substring(0, 2);
    }

    const baseProps = await this.initPage(slug);
    baseProps.countryCode = countryCode;
    baseProps.languageCode = languageCode;
    return {
      ...baseProps
    }
  }

  static async initPage(slug) {
    let page = {};
    let groupedArticles = {};

    if (slug) {
      const { default: pageDao } = await import('../adapters/model/dao/PageDao');
      page = await pageDao.getActivePageBySlug(slug);
      const pageWithSys = await pageDao.getActivePageBySlugWithSysFields(slug);

      if(pageWithSys?.fields?.categories && pageWithSys?.fields?.categories.length > 0) {
        // Fetch article for every categories assign to the page
        // Those are assign to an object by name and passed globally to every block in the page
        // { "category-1" : [{article object}], "category-2" : [{article object}] }
        await asyncForEach(pageWithSys?.fields?.categories, groupedArticles, this.fetchArticles);
      }
    }

  if(page?.fields?.series){
        page?.fields?.series.map((allSeries)=>{
            if(allSeries?.fields?.backgroundAsset?.fields){
                allSeries.fields.backgroundAsset.fields.isBannerImage = true;
            }
            if(allSeries?.fields?.mobileBackgroundAsset?.fields){
                allSeries.fields.mobileBackgroundAsset.fields.isBannerImage = true;
            }
        })
    }
    else{
      page?.fields?.blocks[0]?.fields?.blocks[1]?.fields?.blocks?.map((blocksArr)=>{
        if(blocksArr?.fields?.devicesConfigurations){
          blocksArr?.fields?.devicesConfigurations.map((devices)=>{
            if(devices?.fields?.backgroundAsset?.fields){
              devices.fields.backgroundAsset.fields.isBannerImage = true
            }
          })
        }
        
        if(blocksArr?.fields?.backgroundAsset && blocksArr?.fields?.backgroundAsset?.fields){
          blocksArr.fields.backgroundAsset.fields.isBannerImage = true;
        }

        if(blocksArr?.fields?.mobileBackgroundAsset && blocksArr?.fields?.mobileBackgroundAsset?.fields){
          blocksArr.fields.mobileBackgroundAsset.fields.isBannerImage = true;
        }
        if(blocksArr?.fields?.contentType == "articleListBlock" && blocksArr?.fields?.articleList){
          let newArticleLists = []
          blocksArr?.fields?.articleList.map((articleLists)=>{
            let articlesObj = {
              "fields" : {
                "articleOverview" : articleLists.fields.articleOverview,
                "name" : articleLists.fields.name,
                "contentType": articleLists.fields.contentType,
              },
              "metadata" : articleLists.metadata
            };
            newArticleLists.push(articlesObj)
          })
         blocksArr.fields.articleList = newArticleLists
        }
      })
    }

    page.fields.categories = []

    return {'page' : page, 'articles': groupedArticles};
  }

  static async fetchArticles(category, container) {
    const { default: articleDao } = await import('../adapters/model/dao/ArticleDao');
    let idsToSearch = [];

    let categoryId = category.sys.id;
    let subCategoriesIds = category?.fields?.subcategories?.map(subcategory => subcategory.sys?.id);

    if(subCategoriesIds){
      subCategoriesIds.forEach(subCategoryId => idsToSearch.push(subCategoryId));
    } else {
      idsToSearch.push(categoryId)
    }

    const categoryArticles = await articleDao.getLatestArticleBySubcategories(idsToSearch);
    let finalCategoryArticles = [];
    for(let i=0;i<categoryArticles.length;i++){
      let tempobj = categoryArticles[i]
      finalCategoryArticles.push({
        "metadata" : tempobj["metadata"],
        "sys": tempobj["sys"],
        "fields":{
          "name": tempobj.fields["name"],
          "articleOverview": tempobj.fields["articleOverview"]
        }
      })
    }

    if(finalCategoryArticles && finalCategoryArticles.length > 0) {
      container[category.fields.name] = finalCategoryArticles;
    }
  }

  constructor(props) {
    super(props);
  }

  /**
   * Rendering of the page. This always render the page using a common layout.
   *
   * Override the render method to do otherwise.
   *
   * @returns {*}
   */
  render() {
    let page = this.getPage();
    const pagePath = page.slug.fields.slug;
    let metaData = this.getMetadata()
    if(metaData){
      metaData.pageType = 'page'
    }
    return (
      <Suspense fallback={<Loader />}>
      <Fragment>
      <Suspense fallback={<Loader />}>
        <Meta metadata={metaData} pagePath={pagePath} />
        </Suspense>
        <div className="ob-wrapper">
          <Suspense fallback={<Loader />}>{this.renderBody()}</Suspense>
        </div>
        <Suspense fallback={<Loader />}>
        <GTMScriptFunction languageCode={this.props.languageCode} countryCode={this.props.countryCode} />
        </Suspense>
      </Fragment>
      </Suspense>
    )
  }

  getPage() {
    return this.props.page.fields;
  }

  getArticles() {
    return this.props.articles;
  }

  getMetadata() {
    campaignOverlayStatus(this.props?.page?.fields?.isEnableCampaignOverlay);
    return this.props?.page?.fields?.metadata?.fields;
  }

  /**
   * By default, the page will render the modules of the page.
   * Can be overridden on the child class to do specific rendering.
   * @returns {*|void}
   */
  renderBody() {
    return new Block(this.props.page).renderChildBlocks({ extraAttributes : {articles: this.getArticles()}});
  }
}

Page.propTypes = {
  page: PropTypes.object,
  languageCode: PropTypes.string,
  countryCode: PropTypes.string,
  articles: PropTypes.array
};

export default Page
